import { render, staticRenderFns } from "./TheFormFactura.vue?vue&type=template&id=4a8ced8f&scoped=true&"
import script from "./TheFormFactura.vue?vue&type=script&lang=js&"
export * from "./TheFormFactura.vue?vue&type=script&lang=js&"
import style0 from "./TheFormFactura.vue?vue&type=style&index=0&id=4a8ced8f&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ced8f",
  null
  
)

export default component.exports